/* --------------------------------------------------
Import modules
-------------------------------------------------- */

import Equalizer from '@meteora-digital/equalizer';

/* --------------------------------------------------
Equalizer
-------------------------------------------------- */

const timeouts = {};

window.equalizers = {};
window.equalize = () => {
  clearTimeout(timeouts['equalize']);

  timeouts['equalize'] = setTimeout(() => {
    for (const key in window.equalizers) {
      if (Object.hasOwnProperty.call(window.equalizers, key)) {
        window.equalizers[key].update();
      }
    }
  }, 100);
};

const addEvents = (Controller, container, before) => {
  Controller.on(before, () => {
    container.style.height = container.clientHeight + 'px';
  });

  Controller.on('resize', () => {
    container.style.height = '';
  });
};

window.addEventListener('DOMContentLoaded', () => {
  let index = 0;

  [...document.querySelectorAll('[data-equalize]')].forEach((container) => {
    let ID = container.getAttribute('data-equalize');
    // Set up the equalizer settings
    const settings = {
      container,
      identifiers: ID,
      rows: true,
    };

    if (window.equalizers[ID]) ID = `${ID}-${index}`;

    window.equalizers[ID] = new Equalizer(settings);

    addEvents(window.equalizers[ID], container, 'beforeUpdate');

    index += 1;
  });

  [...document.querySelectorAll('[data-match-height]')].forEach((container) => {
    let ID = container.getAttribute('data-match-height');
    // Set up the equalizer settings
    const settings = {
      container,
      identifiers: ID,
      rows: false,
    };

    if (window.equalizers[ID]) ID = `${ID}-${index}`;

    window.equalizers[ID] = new Equalizer(settings);

    addEvents(window.equalizers[ID], container, 'beforeResize');

    index += 1;
  });

  window.equalize();
});
